'use strict'

// Import services
import ScrollService from './scrollService'
import ResizeService from './resizeService'
import EventEmitterService from 'event-emitter-es6'
import BreakpointListener from './Breakpoint/Breakpoint'

/**
 * A singleton whose properties are individual services.
 *
 * Any service singleton service that needs to be instantiated
 * should be done so in the Services class.
 *
 * Services should not interact with the DOM, that should be
 * left to the Views. Services can simply be used to consolidate
 * an expensive event listener ('scroll', 'resize', etc). or
 * track state (like which modal is open at which time).
 */
export default class Services {
	/**
	 * An object of global application events that can be emitted
	 * by the EventEmitterService
	 */
	static EVENTS = {
		MODULES_LOADED: 'modulesLoaded'
	}

	/**
	 * Services constructor that instantiates each service individually.
	 * To add another services instiate it here.
	 */
	constructor() {
		/**
		 * A service which listens to the `window` scroll event and
		 * invokes an array of callbacks
		 *
		 * @property {Object} ScrollService A singleton instance of the ScrollService class
		 */
		this.ScrollService = new ScrollService()

		/**
		 * A service which listens to the `window` resize event and
		 * invokes an array of callbacks
		 *
		 * @property {Object} ResizeService A singleton instance of the ResizeService class
		 */
		this.ResizeService = new ResizeService()

		/**
		 * A service which allows events to be transmitted between classes
		 *
		 * @property {Object} EventEmitterService A singleton instance of the EventEmitterService class
		 */
		this.EventEmitterService = new EventEmitterService()

		/**
		 * A service which listens to changes to the matchMedia breakpoints
		 * and invokes an array of callbacks
		 *
		 * @property {Object} BreakpointListener A singleton instance of the BreakpointListener class
		 */
		this.BreakpointListener = BreakpointListener.getInstance()
	}

	static getInstance() {
		if (!this.instance) {
			this.instance = new Services()
		}
		return this.instance
	}
}
